import { BaseBankAccountDTOSchema } from "./bank-accounts.dto.js";
export const CreateBankAccountInputDTOSchema = BaseBankAccountDTOSchema.omit({
    id: true,
    createdAt: true,
    updatedAt: true,
    deletedAt: true,
    isDeleted: true,
});
//# sourceMappingURL=create-bank-account.dto.js.map